import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import FAQ from './tabs/faq.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const TabsBlock = makeShortcode("TabsBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "frequently-asked-questions"
    }}>{`Frequently asked questions`}</h1>
    <h2 {...{
      "id": "whats-new-in-the-adobe-experience-platform-mobile-sdk"
    }}>{`What's new in the Adobe Experience Platform Mobile SDK?`}</h2>
    <p>{`There are several new features and benefits of using the Experience Platform Mobile SDK. These SDKs offer extensions to augment core SDK functionality, server-side configuration, and new Adobe Experience Cloud solution functionality. The following table highlights some of the improvements in the Experience Platform Mobile SDK:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Core features`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Experience Platform SDK`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`4x SDK`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Server-side, dynamic configuration`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`✔️`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Programmatic configuration`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`✔️`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`✔️`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Configuration UI`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://experience.adobe.com/#/data-collection/"
            }}>{`Data Collection UI`}</a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://experienceleague.adobe.com/docs/mobile-services/using/eol.html"
            }}>{`Mobile Services (deprecated)`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Partner SDK extensions`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`✔️`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Lifecycle metrics`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`✔️`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`✔️`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`GET/POST postbacks`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`✔️`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`✔️`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Rules & Data Elements`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`✔️`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
      </tbody>
    </table>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Solution`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Experience Platform SDK`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`4x SDK`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Adobe Analytics`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`✔️`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`✔️`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Adobe Analytics - Media Analytics`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`✔️`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`✔️`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Adobe Audience Manager`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`✔️`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`✔️`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Adobe Campaign Classic`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`✔️`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Adobe Campaign Standard`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Push and in-app messaging`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Push only`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Adobe Target`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`✔️`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`✔️`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Places Service`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`✔️`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Adobe Experience Platform Assurance`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`✔️`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "do-i-need-additional-permissions-to-create-a-mobile-property-in-the-data-collection-ui"
    }}>{`Do I need additional permissions to create a mobile property in the Data Collection UI?`}</h2>
    <p>{`If you need access to the Data Collection UI, see the `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/experience-platform/tags/admin/user-permissions.html"
      }}>{`user permissions document`}</a>{`. If you create a web property, you can also create a mobile property. If you do not see the option to create a mobile property, turn off your ad blocker, and refresh the page.`}</p>
    <h2 {...{
      "id": "should-i-create-one-property-per-app-or-multiple-properties-per-app-platform"
    }}>{`Should I create one property per app or multiple properties per app platform?`}</h2>
    <p>{`If your apps send data to the same Adobe Analytics report suites, use the same extensions, rules, and data elements. You should group all of these mobile apps into the same property. If your apps send data to different Adobe Analytics report suites or user different extensions per app, create separate mobile properties. If you group your mobile apps into one property, you can also split them into separate properties over time.`}</p>
    <h2 {...{
      "id": "how-do-i-delete-a-mobile-property-in-the-data-collection-ui"
    }}>{`How do I delete a mobile property in the Data Collection UI?`}</h2>
    <p>{`To delete a mobile property in the Data Collection UI, please read the `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/experience-platform/tags/admin/companies-and-properties.html#delete-a-property"
      }}>{`delete a property tutorial`}</a>{`.`}</p>
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert" />
    <p>{`If you delete a mobile property, you cannot undo this action!`}</p>
    <h2 {...{
      "id": "can-i-safely-upgrade-extensions-within-a-mobile-property-in-the-data-collection-ui-for-published-apps"
    }}>{`Can I safely upgrade extensions within a mobile property in the Data Collection UI for published apps?`}</h2>
    <p>{`Yes, you can safely upgrade extensions within the mobile property. All changes are designed to be backward compatible and will only take effect in your app after you `}<a parentName="p" {...{
        "href": "../home/getting-started/create-a-mobile-property.md#publish-the-configuration"
      }}>{`republish`}</a>{` the mobile property.`}</p>
    <p>{`Additionally, the installation instructions in the mobile property will be refreshed to include the latest versions of mobile platform extensions. These instructions are primarily necessary during the development phase and will be updated even before the property is published.`}</p>
    <h2 {...{
      "id": "how-often-should-i-upgrade-extensions-in-the-data-collection-ui-for-published-mobile-apps"
    }}>{`How often should I upgrade extensions in the Data Collection UI for published mobile apps?`}</h2>
    <p>{`You should always update to the latest version to access new features and show installation instructions for the latest major releases. You can upgrade extensions within the mobile property safely, as updates are backward compatible and won't affect apps already using the published configuration.`}</p>
    <h2 {...{
      "id": "how-often-should-i-upgrade-adobe-experience-platform-sdks-in-mobile-apps"
    }}>{`How often should I upgrade Adobe Experience Platform SDKs in mobile apps?`}</h2>
    <p>{`You should promptly update to the latest major version of Adobe Experience Platform SDKs upon their release. Once you're on the latest version, maintaining a regular update cadence for patch versions ensures your app stays current with the latest enhancements and fixes.  `}</p>
    <p>{`We release major versions of Adobe Experience Platform SDKs when significant updates are needed for underlying platforms, such as increasing the minimum deployment target in iOS or the minimum API level in Android. Minor and patch updates focus on critical bug fixes and enhancements without introducing breaking changes. All Adobe-provided Mobile SDK extensions within the same major version are fully compatible with each other.  `}</p>
    <h2 {...{
      "id": "how-can-i-resolve-the-android-build-error-in-the-react-native-optimize-wrapper"
    }}>{`How can I resolve the Android build error in the React Native Optimize wrapper?`}</h2>
    <p>{`If you have started facing the following error in your  `}<inlineCode parentName="p">{`@adobe/react-native-aepoptimize`}</inlineCode>{` package  `}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Error:`}</strong>{`  `}</p>
      <pre parentName="blockquote"><code parentName="pre" {...{
          "className": "language-plaintext"
        }}>{`TestReactNativeApp/node_modules/@adobe/react-native-aepoptimize/android/src/main/java/com/adobe/marketing/mobile/reactnative/optimize/RCTAEPOptimizeUtil.java:75: error: incompatible types: possible lossy conversion from double to int
    offerWritableMap.putInt("score", offer.getScore());
`}</code></pre>
    </blockquote>
    <p>{`You can resolve this issue by upgrading by upgrading your `}<inlineCode parentName="p">{`@adobe/react-native-aepoptimize`}</inlineCode>{` wrapper to `}<strong parentName="p">{`version 6.1.0 or later`}</strong>{`. This issue arises due to a `}<strong parentName="p">{`breaking change`}</strong>{` in the Android `}<inlineCode parentName="p">{`optimize`}</inlineCode>{` package.`}</p>
    <p>{`For more details, refer to:  `}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/client-sdks/home/release-notes/"
        }}>{`Adobe SDK Release Notes`}</a>{`  `}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/adobe/aepsdk-optimize-android/releases/tag/v3.3.0"
        }}>{`Android Optimize Release Notes`}</a>{`  `}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/adobe/aepsdk-react-native/releases/tag/%40adobe%2Freact-native-aepoptimize%406.1.0"
        }}>{`React Native Optimize Release Notes`}</a>{`  `}</li>
    </ul>
    <h2 {...{
      "id": "general-implementation-and-migration"
    }}>{`General implementation and migration`}</h2>
    <h3 {...{
      "id": "where-can-i-download-the-sdk"
    }}>{`Where can I download the SDK?`}</h3>
    <p>{`The Experience Platform SDK is available through `}<a parentName="p" {...{
        "href": "https://cocoapods.org"
      }}>{`Cocoapods`}</a>{` and `}<a parentName="p" {...{
        "href": "https://gradle.org/"
      }}>{`Gradle`}</a>{`, and `}<a parentName="p" {...{
        "href": "https://github.com/Adobe-Marketing-Cloud/acp-sdks/"
      }}>{`Github`}</a>{`. For more information, please read the `}<a parentName="p" {...{
        "href": "../getting-started/get-the-sdk.md"
      }}>{`get the SDK tutorial`}</a>{`.`}</p>
    <h3 {...{
      "id": "can-i-use-both-the-4x-sdk-and-the-new-experience-platform-sdk-at-the-same-time"
    }}>{`Can I use both the 4x SDK and the new Experience Platform SDK at the same time?`}</h3>
    <p>{`Implementing the two SDKs in your app is not supported.`}</p>
    <p>{`The Experience Platform SDK migrates the locally stored user contexts from the 4x SDKs. Using both SDKs will cause severe data quality issues. For more information, please read the `}<a parentName="p" {...{
        "href": "./upgrade-platform-sdks/index.md"
      }}>{`upgrade to the Experience Platform SDKs tutorial`}</a>{`.`}</p>
    <h3 {...{
      "id": "what-os-and-platform-versions-are-supported"
    }}>{`What OS and platform versions are supported?`}</h3>
    <p>{`For a complete list of supported platforms, please read the `}<a parentName="p" {...{
        "href": "../home/current-sdk-versions.md#supported-platforms"
      }}>{`latest SDK versions document`}</a>{`.`}</p>
    <h3 {...{
      "id": "where-does-the-sdk-store-identities-and-preferences-on-the-app"
    }}>{`Where does the SDK store identities and preferences on the app?`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <FAQ query="platform=android&task=storage-locations" mdxType="FAQ" />
    <p>{`iOS`}</p>
    <FAQ query="platform=ios&task=storage-locations" mdxType="FAQ" />
    <h3 {...{
      "id": "what-is-the-size-of-the-sdk"
    }}>{`What is the size of the SDK?`}</h3>
    <h4 {...{
      "id": "adobe-experience-platform-sdks"
    }}>{`Adobe Experience Platform SDKs`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Extension`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`iOS (KB)`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Android (KB)`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Additional Dependencies†`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Core`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`925`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`497`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Android only: `}<inlineCode parentName="td">{`kotlin-stdlib`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Identity`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`136`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`51`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Lifecycle`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`150`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`59`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Signal`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`18`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`33`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Edge Network extension`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`253`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`99`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Identity for Edge Network`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Consent for Edge Network`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`33`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`25`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Edge Network extension`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Identity for Edge Network`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`69`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`49`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Analytics`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`133`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`95`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Assurance`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`917`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`527`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Android only: `}<inlineCode parentName="td">{`androidx.constraintlayout`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Audience`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`82`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`44`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Identity`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Campaign`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`166`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`80`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Identity`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Campaign Classic`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`34`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`42`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Identity`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Edge Bridge`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`0.84`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`6`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Media`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`283`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`137`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Messaging`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`33`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`77`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Edge Network extension`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Optimize`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`88`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`80`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Edge Network extension`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Places`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`799`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`59`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Target`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`283`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`99`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`User Profile`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`18`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`29`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
      </tbody>
    </table>
    <p>{`The sizes in the table are provided for estimation purposes only, with the following considerations:`}</p>
    <ul>
      <li parentName="ul">{`†Mobile Core, which includes the Rules Engine and Services extensions, is required for all other extensions. The final app size increase can be calculated by adding the Mobile Core size to each of the enabled extensions.`}
        <ul parentName="li">
          <li parentName="ul">{`For example, the iOS app distribution using the Target and Analytics extensions will have a total size increase of 1341 KB. (Core: 925 KB + Analytics: 133 KB + Target: 283 KB).`}</li>
        </ul>
      </li>
      <li parentName="ul">{`The iOS size estimates are based on `}<a parentName="li" {...{
          "href": "https://github.com/google/cocoapods-size"
        }}>{`Google's CocoaPods Size Measurement tool`}</a>{`.`}</li>
      <li parentName="ul">{`The Android size estimates listed refer to unsigned apps and do not account for applying ProGuard.`}</li>
      <li parentName="ul">{`For Android Mobile SDKs, the full list of dependencies for each SDK and version can be found at `}<a parentName="li" {...{
          "href": "https://mvnrepository.com/artifact/com.adobe.marketing.mobile"
        }}>{`Maven Repository`}</a>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "how-can-i-use-proguard-with-the-android-sdk"
    }}>{`How can I use ProGuard with the Android SDK?`}</h3>
    <p>{`Android developer documentation recommends that you should enable shrinking to remove unused code and resources in your release build to make your APK file as small as possible. For more information, please read the `}<a parentName="p" {...{
        "href": "https://developer.android.com/studio/build/shrink-code"
      }}>{`shrink, obfuscate, and optimize your app tutorial`}</a>{`. Shrinking is accomplished by using `}<a parentName="p" {...{
        "href": "https://stuff.mit.edu/afs/sipb/project/android/sdk/android-sdk-linux/tools/proguard/docs/index.html#manual/introduction.html"
      }}>{`ProGuard`}</a>{`. The Experience Platform Mobile SDK for Android comes with default ProGuard rules that are included in the Core `}<inlineCode parentName="p">{`AAR`}</inlineCode>{` package (see `}<inlineCode parentName="p">{`proguard.txt`}</inlineCode>{`). You should use this default package when you implement.`}</p>
    <p>{`Add the following rule to your custom ProGuard rules file, typically labeled `}<inlineCode parentName="p">{`proguard-rules.pro`}</inlineCode>{`. For more information, please read the `}<a parentName="p" {...{
        "href": "https://developer.android.com/studio/build/shrink-code"
      }}>{`shrink, obfuscate, and optimize your app tutorial`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`-keep class com.adobe.marketing.mobile.* {
    <init>(...);
}
`}</code></pre>
    <h3 {...{
      "id": "how-can-i-track-user-engagement-of-push-notifications-using-the-experience-platform-mobile-sdk"
    }}>{`How can I track user engagement of push notifications using the Experience Platform Mobile SDK?`}</h3>
    <p>{`Implementing push notification tracking and measurement with the SDK depends on the Experience Cloud solution being used.`}</p>
    <ul>
      <li parentName="ul">{`For the Adobe Campaign Standard extension, please read the `}<a parentName="li" {...{
          "href": "https://experienceleague.adobe.com/docs/campaign-standard/using/administrating/configuring-mobile/push-tracking.html"
        }}>{`Adobe Campaign standard push tracking tutorial`}</a>{`.`}</li>
      <li parentName="ul">{`For the Adobe Campaign Classic extension, please read the `}<a parentName="li" {...{
          "href": "../solution/adobe-campaign-classic/api-reference.md#tracknotification-api"
        }}>{`Adobe Campaign Classic push notifications tracking tutorial`}</a>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "why-am-i-not-getting-a-valid-configuration-from-data-collection-ui"
    }}>{`Why am I not getting a valid configuration from Data Collection UI?`}</h3>
    <p>{`If you are getting the following errors from the SDK logged in your console, then you have not correctly published the mobile property in Data Collection UI. To correctly publish the mobile property follow the `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/en/docs/experience-platform/tags/publish/overview"
      }}>{`docs here`}</a>{`.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <FAQ query="platform=android&task=configuration-download-error" mdxType="FAQ" />
    <p>{`iOS`}</p>
    <FAQ query="platform=ios&task=configuration-download-error" mdxType="FAQ" />
    <h2 {...{
      "id": "migrating-to-android-mobile-core-2x-and-compatible-extensions"
    }}>{`Migrating to Android Mobile Core 2.x and compatible extensions`}</h2>
    <p>{`See the frequently asked questions for migration `}<a parentName="p" {...{
        "href": "../resources/migration/android/migrate-to-2x.md#frequently-asked-questions"
      }}>{`here`}</a>{`.`}</p>
    <h2 {...{
      "id": "lifecycle"
    }}>{`Lifecycle`}</h2>
    <h3 {...{
      "id": "what-are-lifecycle-metrics"
    }}>{`What are Lifecycle metrics?`}</h3>
    <p>{`Lifecycle metrics are out-of-the-box metrics that are automatically collected when the SDK is first implemented in your app. For more information, please read the `}<a parentName="p" {...{
        "href": "../home/base/mobile-core/lifecycle/index.md"
      }}>{`documentation on Lifecycle metrics`}</a>{`.`}</p>
    <h2 {...{
      "id": "adobe-analytics"
    }}>{`Adobe Analytics`}</h2>
    <p>{`See the `}<a parentName="p" {...{
        "href": "../solution/adobe-analytics/faq.md"
      }}>{`frequently asked questions for Analytics`}</a>{`.`}</p>
    <h2 {...{
      "id": "adobe-experience-platform-edge-network"
    }}>{`Adobe Experience Platform Edge Network`}</h2>
    <h3 {...{
      "id": "does-the-edge-network-extension-support-offline-tracking"
    }}>{`Does the Edge Network extension support offline tracking?`}</h3>
    <p>{`Yes, offline tracking is supported by default when sending XDM Experience events since these events have a required timestamp, and there is no separate setting for this as it used to be in the Adobe Analytics extension. The events are backed up in the persistence layer and then sent to the Edge Network in current session if possible, or queued until the next session when a network connection is available.`}</p>
    <h2 {...{
      "id": "using-experience-platform-swift-sdks-with-tvos"
    }}>{`Using Experience Platform Swift SDKs with tvOS`}</h2>
    <h3 {...{
      "id": "x-is-unavailable-in-application-extension-for-tvos"
    }}>{`'X' is unavailable in application extension for tvOS`}</h3>
    <p>{`You may encounter this error when using the Experience Platform SDK for a tvOS app target, with the following message "'X' is unavailable in application extension for tvOS". This behavior is unexpected for tvOS targets and it seems to be an issue in Xcode where it applies additional checks for `}<inlineCode parentName="p">{`tvOSApplicationExtension`}</inlineCode>{` API compatibility.
Until this issue is resolved in the future Xcode versions, a workaround is to mark the classes or functions with the attribute: `}<inlineCode parentName="p">{`@available(tvOSApplicationExtension, unavailable)`}</inlineCode>{` to suppress the error as in the examples below:`}</p>
    <h4 {...{
      "id": "example"
    }}>{`Example`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`@available(tvOSApplicationExtension, unavailable)
class ErrorThrowingClass {
  ...
}
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`@available(tvOSApplicationExtension, unavailable)
func errorThrowingFunction() {
  ...
}
`}</code></pre>
    <h2 {...{
      "id": "get-help"
    }}>{`Get help`}</h2>
    <ul>
      <li parentName="ul">{`Visit the SDK `}<a parentName="li" {...{
          "href": "https://experienceleaguecommunities.adobe.com/t5/adobe-experience-platform/ct-p/adobe-experience-platform-community"
        }}>{`community forum`}</a>{` to ask questions`}</li>
      <li parentName="ul">{`Contact `}<a parentName="li" {...{
          "href": "https://experienceleague.adobe.com/?support-solution=General#support"
        }}>{`Adobe Experience Cloud customer care`}</a>{` for immediate assistance`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      